export default "__VITE_ASSET__BTY91mIW__"